<div class="col-md-12 row p-0">
    <div class="row" *ngIf="pdfSrc">
        <div class="col" style="width:680px;">
            <ngx-extended-pdf-viewer style="width:100%;" class="letter-pdf" height="80vh" [src]="pdfSrc"
                useBrowserLocale="true"></ngx-extended-pdf-viewer>
        </div>
    </div>
</div>
<div class="row col-md-12 dasheedTopBorder mt-3 pt-3 p-0">
    <div class="col-md-1 p-0">
        <a class="pull-left backContBtn" color="primary" (click)="backLink()">
            <i class="fa back-continue-icon fa-angle-left"></i>
        </a>
    </div>
</div>